import { render, staticRenderFns } from "./GridSeleccion.vue?vue&type=template&id=6ed87bce&"
import script from "./GridSeleccion.vue?vue&type=script&lang=ts&"
export * from "./GridSeleccion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6ed87bce', component.options)
    } else {
      api.reload('6ed87bce', component.options)
    }
    module.hot.accept("./GridSeleccion.vue?vue&type=template&id=6ed87bce&", function () {
      api.rerender('6ed87bce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Asignaciones/GridSeleccion.vue"
export default component.exports